import datapoints from './datapoints';
import onAfterSelectingNode from './helpers/onAfterSelectingNode';
import selectDefaultFolder from './selectDefaultFolder';
import { getCategoryNameFromId, getMasterCategoryList } from 'owa-categories';
import selectNodeInFolderForest from './selectNodeInFolderForest';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { addFrequentlyUsedFolder, getFilteredFolderId } from 'owa-mail-frequently-used-folders';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { action } from 'satcheljs/lib/legacy';
import { getFavoriteIdFromCategoryId, getStore as getSharedFavoritesStore, } from 'owa-favorites';
/**
 * Select a favorite category node
 * @param categoryId the category guid
 */
export default action('selectFavoriteCategory', datapoints.selectFavoriteCategory)(function selectFavoriteCategory(categoryId) {
    var selectNodePromise;
    // Only perform the rest of selecting folder logic when
    // user navigates to a folder with the different folderId
    if (categoryId != getSelectedNode().id) {
        var categoryNodeToSelect = void 0;
        if (isControlFeatureEnabled('tri-favorites-roaming')) {
            var favoriteId = getFavoriteIdFromCategoryId(categoryId);
            var categoryData = getSharedFavoritesStore().outlookFavoriteCategories.get(favoriteId);
            // The favorited category node may have been unfavorited, such as user exiting search and trying to
            // get to previous node, or backstacking etc. where the node may not be present if user unfavorited it
            // in which case select the default folder
            if (!categoryData) {
                selectDefaultFolder();
                return Promise.resolve();
            }
            categoryNodeToSelect = {
                id: categoryData.categoryId,
                treeType: categoryData.treeType,
                type: 4 /* Category */,
            };
        }
        else {
            categoryNodeToSelect = getSharedFavoritesStore().favoriteCategories.get(categoryId);
        }
        selectNodePromise = selectNodeInFolderForest(categoryNodeToSelect);
        // Add category information to the frequently used folder list
        var categoryName = getCategoryNameFromId(categoryId, getMasterCategoryList());
        var categoryFolderIdToAddToFUF = getFilteredFolderId({
            filterType: 'UserCategory',
            filterValue: categoryName,
        });
        addFrequentlyUsedFolder(categoryFolderIdToAddToFUF);
    }
    // Called after selecting same/different persona
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode();
    return selectNodePromise;
});
//# sourceMappingURL=selectFavoriteCategory.js.map